import styled from 'styled-components';

export const TypeOfDataNameInputStyle = {
  Container: styled.div``,
};
